import { type SyncrelState } from "./types";

export interface LinearIssuePayload {
  title: string;
  description: string;
  priority: 1 | 2 | 3 | 4;
  labels: string[];
  metadata: {
    syncrelEntityId: string;
    framework: string | null;
    riceScore?: number;
  };
}

export const exportLinearIssues = (state: SyncrelState, entityIds: string[]): LinearIssuePayload[] => {
  const selected = state.entities.filter((entity) => entityIds.includes(entity.id));
  return selected.map((entity) => {
    const priorityLabel = typeof entity.fields.priority === "string" ? entity.fields.priority : priorityFromScore(entity.fields.riceScore);
    const riceScore = typeof entity.fields.riceScore === "number" ? entity.fields.riceScore : undefined;
    return {
      title: entity.name,
      description: entity.doc.trim() || `# ${entity.name}\n\nImported from Syncrel.`,
      priority: linearPriority(priorityLabel),
      labels: ["Syncrel", priorityLabel],
      metadata: {
        syncrelEntityId: entity.id,
        framework: state.workspace.activeFramework,
        ...(riceScore === undefined ? {} : { riceScore }),
      },
    };
  });
};

const linearPriority = (label: string): 1 | 2 | 3 | 4 => {
  if (label === "Urgent" || label === "High") return 1;
  if (label === "Medium") return 3;
  if (label === "Low") return 4;
  return 2;
};

const priorityFromScore = (score: unknown): string => {
  if (typeof score !== "number") return "Medium";
  if (score >= 500) return "High";
  if (score >= 150) return "Medium";
  return "Low";
};
